
export const earningErrorInterval = 0.05;
export const contributionErrorInterval = 0.05;
export const hourErrorInterval = 3;